import React, { useState, useEffect } from 'react'
import { connect, MapStateToProps } from 'react-redux'
import CartboxE3DButton from './CartboxE3DButton'
import { isGrpLoggedInSelector, isGrpLoginLoadingSelector } from '../../redux/selectors/e3DGrpAuthSelectors'
import { State } from '../../redux/reducers/rootReducer'
import configuredModelIdSelector from '../../redux/selectors/models/configuredModelIdSelector'
import { useTranslation } from 'react-i18next'
import Modal, { ModalClosingButton } from '../modal'
import E3DGrpLogin from '../e3d-components/e3d-grp-login/E3DGrpLogin'
import e3dButtonShouldBeDuplicatedSelector from '../../redux/selectors/e3dButtonShouldBeDuplicatedSelector'
import brandSelector from "../../redux/selectors/brandSelector"

type StateProps = {
    isLoggedIn: ReturnType<typeof isGrpLoggedInSelector>
    isLoading: ReturnType<typeof isGrpLoginLoadingSelector>
    configuredModelId: string
    buttonShouldBeVisible: boolean
    brand: string
}

const mapStateToProps: MapStateToProps<StateProps, {}, State> = (state) => ({
    isLoggedIn: isGrpLoggedInSelector(state),
    isLoading: isGrpLoginLoadingSelector(state),
    configuredModelId: configuredModelIdSelector(state),
    buttonShouldBeVisible: e3dButtonShouldBeDuplicatedSelector(state),
    brand: brandSelector(state),
})

const CartboxE3DButtonContainer: React.FC<StateProps & { setE3DSharingVisible?: (visible: boolean) => void }> = ({
    isLoggedIn,
    isLoading,
    configuredModelId,
    buttonShouldBeVisible,
    setE3DSharingVisible,
    brand,
}) => {
    const { t } = useTranslation()
    const [isLoginModalOpen, setIsLoginModalOpen] = useState(false)
    const [wasLoginModalOpen, setWasLoginModalOpen] = useState(false)

    useEffect(() => {
        if (wasLoginModalOpen && isLoggedIn && !isLoading) {
            setIsLoginModalOpen(false)
            setWasLoginModalOpen(false)
            if (setE3DSharingVisible) {
                setE3DSharingVisible(true)
            }
        }
    }, [isLoggedIn, isLoading, wasLoginModalOpen, setE3DSharingVisible])

    const openModal = () => {
        if (!isLoading) {
            if (isLoggedIn) {
                if (setE3DSharingVisible) {
                    setE3DSharingVisible(true)
                }
            } else {
                setIsLoginModalOpen(true)
                setWasLoginModalOpen(true)
            }
        }
    }

    const closeLoginModal = () => {
        setIsLoginModalOpen(false)
        setWasLoginModalOpen(false)
    }

    const isDisabled = isLoggedIn && !configuredModelId
    const tooltipText = isDisabled ? t('e3d.buttonTooltip') : ''

    return buttonShouldBeVisible ? (
        <>
            <CartboxE3DButton
                isLoggedIn={isLoggedIn}
                isLoading={isLoading}
                openE3DModal={openModal}
                isDisabled={isDisabled}
                tooltipText={tooltipText}
                brand={brand}
            />

            {isLoginModalOpen && (
                <Modal isVisible={true} onClose={closeLoginModal}>
                    <ModalClosingButton onClick={closeLoginModal} />
                    <E3DGrpLogin />
                </Modal>
            )}
        </>
    ) : null
}

export default connect(mapStateToProps)(CartboxE3DButtonContainer)
